import { ActivityType } from 'app/constants/activity'
import { ActivityModel } from 'app/models'
import { getActivityType } from './ActivityTypeResolver'

export const getActivityColor = (
  activity: ActivityModel,
  grayScale: boolean = true,
  forceGrayScale: boolean = false,
) => {
  const type = getActivityType(activity.type)
  return forceGrayScale || (activity.isVehicleSource && grayScale)
    ? getGrayScaleColor(type)
    : getRegularColor(type)
}

export const getRegularColor = (type: ActivityType) => {
  let color = '#333333'

  switch (type) {
    case ActivityType.AVAILABILITY:
      color = '#F1E834'
      break
    case ActivityType.WORK:
      color = '#F5AB46'
      break
    case ActivityType.DRIVING:
      color = '#FF8070'
      break
    case ActivityType.REST:
      color = '#74C7ED'
      break
    case ActivityType.UNKNOWN:
      color = '#D2D2D2'
      break
  }

  return color
}

export const getGrayScaleColor = (type: ActivityType) => {
  let color = '#D2D2D2'

  switch (type) {
    case ActivityType.AVAILABILITY:
      color = '#DCDCDC'
      break
    case ActivityType.WORK:
      color = '#8E8E8E'
      break
    case ActivityType.DRIVING:
      color = '#5A5A5A'
      break
    case ActivityType.REST:
      color = '#B1B1B1'
      break
    case ActivityType.UNKNOWN:
      color = '#D2D2D2'
      break
  }

  return color
}
